'use strict';

import angular from 'angular';
import AdminSitesViewpointsModalController from './viewpoint/modal.component';
import VideoModalController from './video-popup/modal.component';
import InfoModalController from './info/modal.component';
import CalibrationModalController from './calibration/modal.component';
import ErrorModalController from './error/modal.component';
export function Modal($rootScope, $uibModal, appConfig) {
  'ngInject';

  /**
   * Opens a modal
   * @param  {Object} scope      - an object to be merged with modal's scope
   * @param  {String} modalClass - (optional) class(es) to be applied to the modal
   * @return {Object}            - the instance $uibModal.open() returns
   */

  function openModal(scope = {}, modalClass = 'modal-default') {
    var modalScope = $rootScope.$new();

    angular.extend(modalScope, scope);

    return $uibModal.open({
      size: scope.size || 'md',
      template: require('./modal.html'),
      windowClass: modalClass,
      scope: modalScope
    });
  }

  function createAlert(type) {
    return function() {
      let alert = Array.prototype.slice.call(arguments).shift();
      let errorModalOpts = {
        animation: true,
        template: require('./error/modal.html'),
        controller: ErrorModalController,
        controllerAs: '$ctrl',
        resolve: {
          currentError: null
        }
      };
      if(alert) {
        // add the modal type to alert object for red otr orange modal
        alert.type = type;
        /* prints default Warning or Error message
        for modal title if nothing is passed */
        let defaultHeader = type === 'danger' ? 'Error' : type;
        alert.title = alert.title || defaultHeader;
        // beautify the error object, obj indented by one,
        // Run in try/catch block to catch any JSON parsing runtime errors
        try {
          alert.error = JSON.stringify(alert.error, null, 1);
        } catch(ex) {
          // JSON parsing failed and is unrecoverable, we need to update the error and
          // till want to capture the original error, so we pass
          // it to the Error handler to silently log.
          console.error(alert.error);
          alert.error = appConfig.errors.modal.JSON_ERROR;
        }
        errorModalOpts.resolve.currentError = () => {
          return alert;
        };
      }

      let modalInstance = $uibModal.open(errorModalOpts);
      return modalInstance.result;
    };
  }

  // Public API here
  return {

    custom: {
      viewpoint(instance = null) {
        let modalOpts = {
          animation: true,
          template: require('./viewpoint/modal.html'),
          controller: AdminSitesViewpointsModalController,
          controllerAs: '$ctrl',
          resolve: {
            currentViewpoint: null
          }
        };
        if(instance) {
          modalOpts.resolve.currentViewpoint = () => {
            return instance;
          };
        }

        let modalInstance = $uibModal.open(modalOpts);
        return modalInstance.result;
      },
      video(instance, year) {
        let modalOpts = {
          animation: true,
          size: 'lg',
          template: require('./video-popup/modal.html'),
          controller: VideoModalController,
          controllerAs: '$ctrl',
          resolve: {
            selectedVideo: instance,
            selectedYear: year
          }
        };
        if(instance) {
          modalOpts.resolve.selectedVideo = () => {
            return instance;
          };
        }

        let modalInstance = $uibModal.open(modalOpts);
        return modalInstance.result;
      },
      calibrationWizard() {
        let modalOpts = {
          animation: true,
          size: 'lg',
          template: require('./calibration/modal.html'),
          controller: CalibrationModalController,
          controllerAs: '$ctrl',
          windowClass: 'calibration',
          backdrop: 'static',
          keyboard: false
        };

        let modalInstance = $uibModal.open(modalOpts);
        return modalInstance.result;
      },
      generalInfo() {
        let modalOpts = {
          animation: true,
          template: require('./info/modal.html'),
          controller: InfoModalController,
          controllerAs: '$ctrl',
          windowClass: 'info-modal',
          backdrop: 'static',
          keyboard: false
        };

        let modalInstance = $uibModal.open(modalOpts);
        return modalInstance.result;
      }
    },

    /* Confirmation modals */
    confirm: {

      /**
       * Create a function to open a delete confirmation modal (ex. ng-click='myModalFn(name, arg1, arg2...)')
       * @param  {Function} del - callback, ran when delete is confirmed
       * @return {Function}     - the function to open the modal (ex. myModalFn)
       */
      delete(del = angular.noop) {
        /**
         * Open a delete confirmation modal
         * @param  {String} name   - name or info to show on modal
         * @param  {All}           - any additional args are passed straight to del callback
         */
        return function() {
          var args = Array.prototype.slice.call(arguments);
          var name = args.shift();
          var deleteModal;

          deleteModal = openModal({
            modal: {
              dismissable: true,
              title: 'Confirm Delete',
              html: `<p>Are you sure you want to delete <strong>${name}</strong> ?</p>`,
              buttons: [{
                classes: 'btn-danger',
                text: 'Delete',
                click(e) {
                  deleteModal.close(e);
                }
              }, {
                classes: 'btn-default',
                text: 'Cancel',
                click(e) {
                  deleteModal.dismiss(e);
                }
              }]
            }
          }, 'modal-danger');

          deleteModal.result.then(function(event) {
            del.apply(event, args);
          });
        };
      },
      custom(type, action = angular.noop) {
        return function() {
          let args = Array.prototype.slice.call(arguments),
            warningModalContents = args.shift(),
            confirmModal;
          confirmModal = openModal({
            modal: {
              dismissable: true,
              title: '<i class="fa fa-exclamation-triangle"></i>&nbsp;' + warningModalContents.heading,
              html: '<p>' + warningModalContents.body + '</p>',
              buttons: [{
                classes: 'btn-' + type,
                text: warningModalContents.confirmText,
                click: function(e) {
                  confirmModal.close(e);
                }
              }, {
                classes: 'btn-default',
                text: warningModalContents.denyText,
                click(e) {
                  confirmModal.dismiss(e);
                }
              }]
            }
          }, 'modal-' + type);
          confirmModal.result.then(function(event) {
            action.apply(event, args);
          }, angular.noop);
        };
      }
    },
    //Opens a customozied alert confirmation modal
    alert: {
      error(alert) {
        return createAlert('danger')(alert); // red danger modal themed
      },
      warn(alert) {
        return createAlert('warning')(alert); // orange warning modal themed
      }
    }
  };
}

export default angular.module('fplTruescapeComApp.Modal', [])
  .factory('Modal', Modal)
  .name;



// WEBPACK FOOTER //
// ./client/components/modal/modal.service.js